import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {SteelProfile} from '../../steel-profile';
import {AbstractControl, FormBuilder, Validators} from '@angular/forms';
import {CintacValidators} from '../../../_shared/cintac-validators';

@Component({
    selector: 'app-profile-common-form',
    templateUrl: './profile-common-form.component.html',
    styleUrls: ['../../../project/project-form-components/project-form.css']
})
export class ProfileCommonFormComponent implements OnInit, OnChanges {

    @Input() profile: SteelProfile;
    @Input() create: boolean;
    @Output() commonIsValid = new EventEmitter<boolean>();
    profileData: AbstractControl;

    validationMessages = {
        'weight': {
            'required': 'Ingresar peso',
            'pattern': CintacValidators.getPositiveFloatValidatorMessage(),
        }
    };

    formErrors = {
        'weight': ''
    };

    constructor(private _fb: FormBuilder) {
        this.profileData = this._fb.group({
            weight: ['', [Validators.required, CintacValidators.positiveFloatValidator()]],
            sap_code: ['', []],
        });
    }

    resetForm() {
        this.profileData.reset({
            weight: this.profile.weight,
            sap_code: this.profile.sap_code,
        });
    }

    ngOnInit(): void {
        this.resetForm();
        this.profileData.valueChanges.subscribe(values => this.onValueChanged());
    }

    ngOnChanges() {
        if (!this.create) {
            this.resetForm();
        }
    }

    private onValueChanged() {
        const form = this.profileData;
        this.updateProfile();
        Object.keys(this.formErrors).forEach(field => {
            this.formErrors[field] = '';
            const control = form.get(field);
            if (control.dirty && !control.valid) {
                const messages = this.validationMessages[field];
                for (const key in control.errors) {
                    if (control.errors.hasOwnProperty(key)) {
                        this.formErrors[field] += messages[key] + ' ';
                    }
                }
            }
        });
        this.commonIsValid.emit(this.profileData.valid);
    }

    updateProfile() {
        this.profile.weight = this.profileData.value.weight;
        this.profile.sap_code = this.profileData.value.sap_code;
    }

}



// WEBPACK FOOTER //
// ./src/app/steel-profile/steel-profile-forms/profile-common-form/profile-common-form.component.ts